import { Component } from 'react';
import { connect } from 'react-redux';
import { sendErrorInfoToApi } from 'lib/api';

import type { ReduxRootState } from 'types';

interface Props extends Pick<ReduxRootState, 'user'> {
  children: React.ReactNode;
  onError: () => void;
}

const EditorBlockErrorBoundary = connect((state: ReduxRootState) => ({
  user: state.user
}))(
  class extends Component<Props, {}> {
    constructor(props: Props) {
      super(props);
    }

    async componentDidCatch(error, errorInfo) {
      const { onError, user } = this.props;
      if (onError) onError();

      await sendErrorInfoToApi({
        error,
        errorInfo,
        user: { id: user?.id, roles: user?.roles }
      });
    }

    render() {
      const { children } = this.props;

      return children;
    }
  }
);

export default EditorBlockErrorBoundary;
